import React, { Component } from 'react';
import capitalize from 'capitalize';
import Select from 'react-select';

export default class HashElementForm extends Component {
  constructor(props) {
    super(props);
    this.keynameInputs = [];
    this.state = this.parseInitialState(props);
    this.lastID = props.element.id;
  }

  UNSAFE_componentWillReceiveProps(props) {
    this.setState(this.parseInitialState(props));
  }

  parseInitialState(props) {
    let element = props.element;

    if (element.id !== this.lastID) {
      this.keynameInputs[element.id] = element.key.default !== '';
    }
    this.lastID = element.id;

    return { element: element, enabled: props.enabled };
  }

  keynameInput() {
    return this.keynameInputs[this.state.element.id];
  }

  typeOptions() {
    return this.props.types.map((type) => {
      return {
        value: type,
        label: capitalize.words(type.replace(/_/g, ' ')),
      };
    });
  }

  updateState(obj) {
    this.props.onChange(Object.assign({}, this.state.element, obj));
  }

  updateLabel(label) {
    let obj = { label: label };

    if (!this.keynameInput()) {
      obj.key = Object.assign({}, this.state.element.key, {
        default: label.toLowerCase().replace(/ /g, '_'),
      });
    }

    this.updateState(obj);
  }

  updateKey(obj) {
    let newKey = Object.assign({}, this.state.element.key, obj);

    if (typeof obj.default !== 'undefined') {
      this.keynameInputs[this.state.element.id] = true;
    }

    this.updateState({ key: newKey });
  }

  updateValue(obj) {
    let newValue = Object.assign({}, this.state.element.value, obj),
      root = {};

    if (
      typeof obj.types !== 'undefined' &&
      obj.types.length > 1 &&
      obj.types.indexOf('hash') > -1
    ) {
      return this.updateState({
        value: Object.assign(
          { errors: ["You can't have type Hash along with other types"] },
          this.state.element.value,
        ),
      });
    }

    if (newValue.types.indexOf('hash') > -1) {
      root.required = true;
      newValue.mutable = true;
      newValue.multiple = false;
      newValue.default = '';
    }

    this.updateState(Object.assign({ value: newValue }, root));
  }

  getOptionValue(options) {
    return options.map((opt) => opt.value);
  }

  getOptionFromValue(values, options) {
    return options.filter((opt) => values.indexOf(opt.value) > -1);
  }

  isHash() {
    return this.state.element.value.types.indexOf('hash') > -1;
  }

  errorsFor(attr) {
    const obj = attr === 'root' ? this.state.element : this.state.element[attr];

    if (typeof obj.errors === 'undefined') {
      return [];
    }
    return obj.errors;
  }

  renderErrorsFor(attr) {
    return this.errorsFor(attr).map((errorMessage, index) => {
      return (
        <div
          key={`${attr}${index}`}
          className='ui alert message'
        >
          {errorMessage}
        </div>
      );
    });
  }

  render() {
    return (
      <div className='ui form'>
        <h3 className='ui header'>Element Properties</h3>
        {this.renderErrorsFor('root')}

        <div className='field'>
          <div className='ui checkbox'>
            <input
              checked={this.state.element.required}
              disabled={!this.state.enabled}
              id='scope_required'
              type='checkbox'
              onChange={(e) => this.updateState({ required: e.target.checked })}
            />
            <label htmlFor='scope_required'>This Element is required</label>
          </div>
        </div>
        <div className='field'>
          <label>Element Description</label>
          <textarea
            disabled={!this.state.enabled}
            value={this.state.element.description}
            onChange={(e) => this.updateState({ description: e.target.value })}
          />
        </div>

        <h4 className='ui header'>Settings for the Key</h4>
        {this.renderErrorsFor('key')}

        {/* --------- Key -------------*/}
        <div className='field'>
          <label>Label</label>
          <input
            disabled={!this.state.enabled}
            type='text'
            value={this.state.element.label || ''}
            onChange={(e) => this.updateLabel(e.target.value)}
          />
        </div>

        <div className='field'>
          <label>Key Name</label>
          <input
            autoFocus={true}
            disabled={!this.state.enabled}
            type='text'
            value={this.state.element.key.default}
            onChange={(e) => this.updateKey({ default: e.target.value })}
          />
        </div>

        <div className='selectField'>
          <label>Key Types</label>
          <Select
            multi
            disabled={!this.state.enabled}
            options={this.typeOptions().filter((opt) => opt.value !== 'hash')}
            value={this.getOptionFromValue(
              this.state.element.key.types,
              this.typeOptions(),
            )}
            onChange={(keyOption) =>
              this.updateKey({ types: this.getOptionValue(keyOption) })
            }
          />
        </div>

        <div className='grouped fields'>
          <div className='field'>
            <div className='ui checkbox'>
              <input
                checked={this.state.element.key.multiple}
                disabled={!this.state.enabled}
                id='scope_key_multiple'
                type='checkbox'
                onChange={(e) => this.updateKey({ multiple: e.target.checked })}
              />
              <label htmlFor='scope_key_multiple'>Accept multiple keys</label>
            </div>
          </div>
          <div className='field'>
            <div className='ui checkbox'>
              <input
                checked={this.state.element.key.mutable}
                disabled={!this.state.enabled}
                id='scope_key_mutable'
                type='checkbox'
                onChange={(e) => this.updateKey({ mutable: e.target.checked })}
              />
              <label htmlFor='scope_key_mutable'>
                Users can change the key
              </label>
            </div>
          </div>
        </div>

        {/* --------- Value -------------*/}
        <h4 className='ui header'>Settings for the Value</h4>
        {this.renderErrorsFor('value')}

        <div className='selectField'>
          <label>Value Types</label>
          <Select
            multi
            disabled={!this.state.enabled}
            options={this.typeOptions()}
            value={this.getOptionFromValue(
              this.state.element.value.types,
              this.typeOptions(),
            )}
            onChange={(option) =>
              this.updateValue({ types: this.getOptionValue(option) })
            }
          />
        </div>

        <div className='field'>
          <label>Default Value</label>
          <input
            disabled={this.isHash() || !this.state.enabled}
            type='text'
            value={this.state.element.value.default}
            onChange={(e) => this.updateValue({ default: e.target.value })}
          />
        </div>

        <div className='grouped fields'>
          <div className='field'>
            <div className='ui checkbox'>
              <input
                checked={this.state.element.value.multiple}
                disabled={this.isHash() || !this.state.enabled}
                id='scope_value_multiple'
                type='checkbox'
                onChange={(e) =>
                  this.updateValue({ multiple: e.target.checked })
                }
              />
              <label htmlFor='scope_value_multiple'>
                Accept multiple values
              </label>
            </div>
          </div>
          <div className='field'>
            <div className='ui checkbox'>
              <input
                checked={this.state.element.value.mutable}
                disabled={this.isHash() || !this.state.enabled}
                id='scope_value_mutable'
                type='checkbox'
                onChange={(e) =>
                  this.updateValue({ mutable: e.target.checked })
                }
              />
              <label htmlFor='scope_value_mutable'>
                Users can change the value
              </label>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
